import { TSalesData, TSalesDataUploadResp } from 'pages/SalesData/types';
import { cdmApi } from '.';

const PREFIX = '/sales-data';

const SalesDataApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getSalesData: builder.query<TSalesData[], void>({
            query: (params) => ({ url: `${PREFIX}/`, method: 'get', params }),
            providesTags: () => [{ type: 'SalesData', id: 'LIST' }],
        }),

        uploadSalesData: builder.mutation<TSalesDataUploadResp, { data: FormData; uploadId: string }>({
            query: ({ data, uploadId }) => ({
                url: `${PREFIX}/upload`,
                method: 'POST',
                data,
                headers: { 'x-sales-data-upload-id': uploadId },
                responseType: 'arraybuffer',
            }),
            invalidatesTags: [{ type: 'SalesData', id: 'LIST' }],
        }),

        downloadSalesData: builder.query<any, any>({
            query: (data) => ({ url: `${PREFIX}/download`, method: 'post', data, responseType: 'arraybuffer' }),
        }),

        downloadSalesDataTemplate: builder.query<ArrayBuffer, void>({
            query: (params) => ({
                url: `${PREFIX}/excel/template/export`,
                method: 'get',
                params,
                responseType: 'arraybuffer',
            }),
        }),

        downloadErrorFile: builder.query<ArrayBuffer, { [key: string]: any }>({
            query: (data) => ({
                url: `${PREFIX}/excel/errors/export`,
                method: 'POST',
                data,
                responseType: 'arraybuffer',
            }),
        }),
    }),

    overrideExisting: false,
});

export const {
    useUploadSalesDataMutation,
    useGetSalesDataQuery,
    useLazyDownloadSalesDataQuery,
    useLazyDownloadSalesDataTemplateQuery,
    useLazyDownloadErrorFileQuery,
} = SalesDataApi;
